import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=c5c6a1e8"
import script from "./NovoUsuario.vue?vue&type=script&lang=js"
export * from "./NovoUsuario.vue?vue&type=script&lang=js"
import style0 from "./NovoUsuario.vue?vue&type=style&index=0&id=c5c6a1e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports